import cx from 'classnames';

import { noop } from 'helpers/utils';
import i18n from 'i18n/config';
import CloseIcon from 'styles/assets/icons/CloseIcon';
import GlobalIcon from 'styles/assets/icons/GlobalIcon';

import styles from './IndiaOrGlobalModal.module.scss';

const webAddressChanged = i18n.t('common:webAddressChanged');

const IndiaOrGlobalModalHeader = ({ onClose }: { onClose: () => void }) => {
  return (
    (<div className={styles.header} data-palette="IndiaOrGlobalModalHeader">
      <div className={styles.title}>
        <h2>
          <GlobalIcon className={styles.globalIcon} />
          {webAddressChanged}
        </h2>
      </div>
      <div
        data-testid="closeButton"
        className={cx(
          'flex-set flex--content-center flex--align-items-center',
          styles.closeButton
        )}
        onClick={onClose}
        role="button"
        tabIndex={0}
        onKeyDown={noop}
      >
        <CloseIcon width={10} height={10} />
      </div>
    </div>)
  );
};

export default IndiaOrGlobalModalHeader;
